export const root = '/feature-flags';

export const settings = `${root}/settings`;
